import React, {useState, useEffect} from "react";
import { db } from "../firebase";
import Header from "../Components/Header/Header";
import { async } from "@firebase/util";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import auth from "../firebase";


const Login = ({isLoading})  =>{
    // const [isLoading, setIsLoading] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) =>{
        e.preventDefault();
        console.log({"email" : email, "password": password});

        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            setEmail('');
            setPassword('');
            
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            alert(errorMessage);
        });
       
    }

    return(
        <>
            <Header />
            {isLoading ? 
            <h1 className="text-white"> Loading ...</h1> :
            <div className="flex items-center">
                <div class="w-1/3 max-w-md  bg-gray-800  border-gray-200 rounded-lg mx-auto mt-14  sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
                    <form class="space-y-6"onSubmit={handleSubmit}>
                        <h5 class="text-xl font-medium text-white dark:text-white text-center">LogIn</h5>

                        {/* <div>
                            <label for="Name" class="block mb-2 text-sm font-medium text-white dark:text-white">Name</label>
                            <input type="text" name="name" id="name" class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="Add Admin Name" required />
                        </div> */}
                        <div>
                            <label for="Company code" class="block mb-2 text-sm font-medium text-white dark:text-white">Email</label>
                            <input type="text" data-testId="email-input" name="company code" id="code" onChange={(e)=> setEmail(e.target.value)} class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="Add Email Address" required />
                        </div>

                        
                        <div>
                            <label for="password" class="block mb-2 text-sm font-medium text-white">Your password</label>
                            <input type="password" data-testId="password-input" name="password" id="password" onChange={(e)=> setPassword(e.target.value)} placeholder="••••••••" class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required />
                        </div>
                    
                        <button type="submit" class="w-full h-8 text-white bg-gray-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Sign in</button>
                        <div class="">
                            {/* <p class="text-center text-gray-500">Forget password?</p> */}
                        </div>
                        <div class="text-sm font-medium text-gray-500 dark:text-gray-300 text-center pt-[-12">
                            {/* Don't have an account? <a href="#" class="text-blue-700 hover:underline  dark:text-blue-500">Register</a> */}
                        </div>
                    </form>
                </div>
            </div>
            }
        </>
    )
}


export default Login